<template>
  <div class="step">
    <h2>Completa il tuo profilo</h2>
    <p class="subtitle text-medium">
      Per accedere a MySace e scoprire i nostri servizi e gli eventi pensati per te completa il tuo profilo con poche informazioni
    </p>
    <div class="actions">
      <button
        class="button primary"
        @click="!disabled ? navigate('next') : null"
      >
        Avanti
      </button>
      <button
        class="back"
        @click="navigate('logout')"
      >
        Abbandona
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Welcome',
  props: {},
  data() {
    return {};
  },
  methods: {
    navigate(step) {
      const obj = {
        navigate: step,
      };
      this.$emit('navigate', obj);
    },
  },
};
</script>
